// extracted by mini-css-extract-plugin
export var block = "example-module--block--3cf9e";
export var col = "example-module--col--3f820";
export var desc = "example-module--desc--f682e";
export var example = "example-module--example--997ae";
export var icon = "example-module--icon--ad9b6";
export var item = "example-module--item--5310d";
export var item1 = "example-module--item-1--5d917";
export var item2 = "example-module--item-2--84dec";
export var item3 = "example-module--item-3--1392e";
export var item4 = "example-module--item-4--4792b";
export var num = "example-module--num--31ff1";